// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../utils/formatNumber';
import { currencies } from '../../../../staticData/currencies';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  padding: theme.spacing(2),
  borderRadius: '12px',
  background: `linear-gradient(135deg, ${alpha(theme.palette.info.main, 0.08)} 0%, ${alpha(theme.palette.info.light, 0.04)} 100%)`,
  border: 'none',
  boxShadow: `0 2px 8px ${alpha(theme.palette.info.main, 0.12)}`,
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: `0 6px 16px ${alpha(theme.palette.info.main, 0.2)}`,
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '3px',
    background: `linear-gradient(90deg, ${theme.palette.info.main} 0%, ${theme.palette.info.light} 100%)`,
  },
}));

// ----------------------------------------------------------------------

export default function UnitSold(props) {
  // console.log('UnitSold props', props);
  const { unit, title } = props;
  const _user = JSON.parse(localStorage.getItem('user'));
  const _symbol = currencies.find((c) => c.code === (_user?.primaryCurrency || 'USD'))?.symbol || '$';
  return (
    <RootStyle>
      <Typography
        variant="subtitle2"
        sx={{
          color: (theme) => theme.palette.info.dark,
          fontWeight: 600,
          mb: 0.8,
          fontSize: '0.7rem',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          opacity: 0.9,
        }}
      >
        {title ? title : 'Units Sold'}
      </Typography>
      <Typography
        variant="h5"
        sx={{
          color: (theme) => theme.palette.info.main,
          fontWeight: 700,
          fontSize: '1.3rem',
        }}
      >
        {(props.sign ? _symbol : '') + fShortenNumber(unit)}
      </Typography>
    </RootStyle>
  );
}
